// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "group-c01r0";
var _3 = "item-h2RpY";
var _4 = "label-182cb";
var _5 = "value-SRm0P";
export { _1 as "__esModule", _2 as "group", _3 as "item", _4 as "label", _5 as "value" }
export default { "__esModule": _1, "group": _2, "item": _3, "label": _4, "value": _5 }
